export default __webpack_public_path__ + "static/media/ba.2d7f430f.svg";